let cashier_MembershipQueryResult = require("../../templates/cashier/MembershipQueryResult.handlebars");
let cashier_requestPassword = require("../../templates/cashier/requestPassword.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";
import i18n from"../../utils/i18n";
import PrinterConverterUtil from"../../utils/PrinterConverterUtil.js";
import ModalView from "../comp/ModalView.js";
let DbRecorder = require("../../recorder/DbRecorder.js");

let main = function () {
    return Backbone.View.extend({
        events: {
            'keyup .membership-input': "_onSearchInputKeyUp",
            'click .btn.search': "_searchMembership",
            'click .btn.weixinMembership': "_weixinMembership",
            'click .btn.clear': "_clearMembership",
            'click .btn.confirm': "_confirmMembership",
            'click .btn.score': "_scoreMembership",
            'click .btn.record': "_associateMembership",
            'click .printQrCode': "_printQrCode",
            'click .member-info': "_selectorMembership"
        },
        membership: null,
        memberships: null,
        initialize: function () {
            this._checkBillMembership();
        },
        _onSearchInputKeyUp: function (event) {
            if (event.keyCode == 13) {
                this._searchMembership();
            }
        },
        _checkBillMembership: function () {
            var jxhr, self = this;
            jxhr = $.post("/membership/checkBillMembership", {billId: this.model.get('billId')});
            jxhr.done(function (response) {
                if (response.success) {
                    self._buildMemberTem([response.membership]);
                }
            });
            jxhr.fail(function (response) {

            });
        },
        _buildMemberTem: function (membershipList) {
            var self = this, memberships, membership;
            self.$(".qrcode").addClass("hidden");
            self.$(".memberships").removeClass("hidden");
            self.$(".buttons").removeClass("hidden");
            var membershipDetailEl = $(cashier_MembershipQueryResult({
                currencySymbol: POS.getRestaurant().get("currencySymbol"),
                memberships: membershipList
            }));
            self.$(".memberships").html(membershipDetailEl);
            memberships = membershipList;
            if (memberships && memberships.length > 0) {
                self.$(".memberships").find('.member-info').first().addClass('selected');
                self.$(".btn.confirm").removeAttr("disabled").addClass("btn-success");
                self.$(".btn.score").removeAttr("disabled");
                membership = _.first(memberships);
            } else {
                membership = null;
                self.$(".btn.confirm").attr("disabled", "disabled").addClass("btn-success");
                self.$(".btn.score").attr("disabled", "disabled");
            }
            self.memberships = memberships;
            self.membership = membership;
        },
        _searchMembership: function () {
            var self = this, memberships, membership, jxhr, restaurant = POS.getRestaurant(), name = self.$(".membership-input").val().trim();
            self.$(".not-enough").addClass("hidden");
            if (!name || self.$(".btn.search").attr("disabled")) {
                return false;
            }
            self.$(".buttons").addClass("hidden");
            self.$(".qrCodeButtons").addClass("hidden");
            self.$(".btn.search").attr("disabled", "disabled");
            POS.showLoading(true);
            jxhr = $.post("/membership/query", {restaurantId: restaurant.id, name: name});
            jxhr.done(function (response) {
                self._buildMemberTem(response.memberships);
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
                self.$(".btn.search").removeAttr("disabled");
            });
            return false;
        },

        _printQrCode: function () {
            var self = this, qrUrl = $(".qrCodeImg").attr("src"), jxhr;
            POS.showLoading(true);
            jxhr = $.post("/tooieWeixin/createQrcode", {url: qrUrl});
            jxhr.done(function (response) {
                if (response.success) {
                    if (typeof(chrome) !== 'undefined' && typeof(chrome.runtime) !== 'undefined') {
                        chrome.runtime.sendMessage(DbRecorder.read("chromeAppId"), {msg: PrinterConverterUtil.printQrcode(response.image)});
                    }
                }
            });
            jxhr.always(function () {
                POS.showLoading(false);
            })

        },
        _weixinMembership: function () {
            var self = this, memberships, membership;
            self.$(".btn.weixinMembership").attr("disabled", "disabled");
            self.$(".buttons").addClass("hidden");
            self.$(".qrCodeButtons").addClass("hidden");
            $.get("/membership/_showPaymentQrCode", {rId: POS.getRestaurant().id}, function (response) {
                self.$(".qrcode").html(response);
                self.$(".qrcode").removeClass("hidden");
                self.$(".qrCodeButtons").removeClass("hidden");
                self.$(".btn.weixinMembership").removeAttr("disabled");
                self.$(".memberships").addClass("hidden");
                self.eventId = $(response).find('.qrCodeImg').data('id');

                function sleep(n) {
                    var start = new Date().getTime();
                    while (true)  if (new Date().getTime() - start > n) break;
                }

                function check() {
                    $.get("/membership/getMembershipByQrCode", {eventId: self.eventId}, function (response) {
                        if (response.success) {
                            self.$(".qrCodeButtons").addClass("hidden");
                            self.$(".qrcode").addClass("hidden");
                            self.$(".memberships").removeClass("hidden");
                            self.$(".buttons").removeClass("hidden");
                            var membershipDetailEl = $(cashier_MembershipQueryResult({
                                currencySymbol: restaurant.get("currencySymbol"),
                                memberships: response.memberships
                            }));
                            self.$(".memberships").html(membershipDetailEl);
                            self.$(".memberships").find('.member-info').first().addClass('selected');
                            self.$(".btn.clear").removeAttr("disabled").addClass("btn-danger");
                            self.$(".btn.confirm").removeAttr("disabled").addClass("btn-success");
                            memberships = _.where(response.memberships, {name: name});
                            membership = memberships.length > 0 ? _.first(memberships) : _.first(memberships);
                            self.memberships = memberships;
                            self.membership = membership;
                        } else if (self.model.get("membershipModalIsShow")) {
                            sleep(3000);
                            check();
                        }
                    });
                }

                check();
            });
        },

        _fillMembership: function (membership) {
            var self = this;
            if (membership) {
                self.$(".card-type").text(membership.scheme.name);
                self.$(".card-no").text(membership.name);
                self.$(".member-name").text(membership.member);
                self.$(".balance").text(membership.credit);
                self.$(".phone").text(membership.phone);
                if (membership.scheme.discount) {
                    if (membership.scheme.discount.disabled) {
                        self.$(".disabled-discount").show();
                    } else {
                        self.$(".disabled-discount").hide();
                    }
                    self.$(".discount").text(membership.scheme.discount.name);
                } else {
                    self.$(".discount").text("");
                }
            } else {
                self.$(".card-type").text("");
                self.$(".card-no").text("");
                self.$(".member-name").text("");
                self.$(".balance").text("0.00");
                self.$(".phone").text("");
                self.$(".discount").text("");
            }

        },
        _clearMembership: function () {
            var self = this;
            self.$(".not-enough").addClass("hidden");
            self.model.unset("membership");
            self.model.unset("membershipid");
            self._fillMembership();
            self.$(".btn.clear").attr("disabled", "disabled").removeClass("btn-danger");
            self.$(".btn.confirm").attr("disabled", "disabled").removeClass("btn-success");
        },

        _selectorMembership: function (evt) {
            var self = this, target = $(evt.currentTarget), name = target.find('.card-no').text().trim(), membership;
            membership = _.where(self.memberships, {cardNo: name});
            self.membership = _.first(membership);
            self.$('.memberships').find('.member-info').removeClass('selected');
            target.addClass('selected');
        },
        _scoreMembership: function () {
            var self = this, membership = self.membership,
                params = {membership: membership, membershipid: membership.id, recode: true};
            self.model.unset('membershipid', {silent: true});
            self.model.set(params);
        },
        _confirmMembership: function () {
            var self = this, membership = self.membership;
            //if current member has the password then confirm the password
            POS.showLoading(true);
            var checkPasswordRequest = $.post("/api/membership/checkPassword/" + membership.id, {eventId: self.eventId});
            checkPasswordRequest.done(function (response) {
                if (response.result) {
                    self._modalPasswordDialogue();
                } else {
                    //confirm the payment
                    self._confirmedPayment();
                }
            });
            checkPasswordRequest.fail(function (response) {
                alert(i18n.msg("pos.network.problem.text"))
            });
            checkPasswordRequest.always(function () {
                POS.showLoading(false);
            })
        },

        _modalPasswordDialogue: function () {
            var self = this, membership = self.membership;
            //modal confirm box
            var requestPasswordModal = new ModalView({
                body: $(cashier_requestPassword({})),
                hideFooter: true
            }).render();
            $(requestPasswordModal.el).find("input[type=password]").focus();
            requestPasswordModal.$el.find('.modal-content').addClass('passwordConfirmModal');
            //confirm button
            $(requestPasswordModal.el).find(".btn.btn-lg.btn-green.confirm").on("click", function () {
                var password = $(requestPasswordModal.el).find("input[type=password]").val();
                if (password.length === 0) {
                    $(requestPasswordModal.el).find("h4").show();
                    return false
                }
                // send confirm request
                POS.showLoading(true);
                var confirmPasswordRequest = $.post("/api/membership/confirmPassword/" + membership.id + "/" + password, {});
                confirmPasswordRequest.done(function (response) {
                    if (response.result) {
                        requestPasswordModal.close();
                        self._confirmedPayment();
                    } else {
                        //deny the payment
                        $(requestPasswordModal.el).find("h4").show();
                        $(requestPasswordModal.el).find("input[type=password]").val(""); //reset the password
                    }
                });
                confirmPasswordRequest.fail(function (response) {
                    alert(i18n.msg("pos.network.problem.text"))
                });
                confirmPasswordRequest.always(function () {
                    POS.showLoading(false);
                });
            })
        },

        _associateMembership: function() {
            this._confirmedPayment(0);
        },

        _confirmedPayment: function (amount) {
            var self = this, membership = self.membership, shouldPayAmount = 0,
                params = {membership: membership, membershipid: membership.id};

            if(amount != undefined) {
                params.membershipPayment = amount;
            }

            self.model.unset('membershipid', {silent: true});
            self.model.set(params);
        },
        _calculateMembership: function (membership) {
            var self = this, shouldPayAmount = self.model.get("currentOriginalBill").get("shouldPayAmount"), enough = false;
            if (shouldPayAmount <= membership.credit) {
                self.model.set({closemembership: true});
                self.$(".member-info[data-id='" + membership.id + "']").find(".not-enough").addClass("hidden");
                enough = true;
            } else {
                self.$(".member-info[data-id='" + membership.id + "']").find(".not-enough").removeClass("hidden");
                enough = false;
            }
            return enough;
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/cashier/MembershipSelectorView.js